import { computed, ref, nextTick } from 'vue';

import filled from '../javascripts/filled';
import match, { sanitize } from '../javascripts/search';

const LIMIT_HEIGHT_IN_PX = 235;

// eslint-disable-next-line no-unused-vars
export default function selector(props, value, refSearch, refList, disabled) {
  const visible = ref(false);
  const query = ref('');
  const limited = ref(false);

  const results = computed(() => {
    let { options } = props.properties;
    const current = String(value.value);

    if (filled(value.value) && !options.some((o) => o.value === current)) {
      options = [
        ...options,
        { label: value.value, value: value.value },
      ];
    }

    if (query.value) {
      return options.filter((i) => match(query.value, [i.label, i.value, i.searchable]));
    }

    return options;
  });

  async function toggle(bool, text) {
    if (disabled.value) {
      return;
    }

    visible.value = typeof bool === 'boolean' ? bool : !visible.value;

    if (visible.value) {
      const max = document.body.scrollHeight;

      await nextTick();

      if (refSearch.value) {
        refSearch.value.focus();

        if (typeof text === 'string') {
          query.value = text;
        }
      }

      const listRect = refList.value?.getBoundingClientRect() || {};
      const { top } = listRect;

      limited.value = Math.min(LIMIT_HEIGHT_IN_PX, max - top);
    }
  }

  function search(e) {
    if (/^[a-z0-9]$/i.test(e.key)) {
      e.preventDefault();

      toggle(true, sanitize(e.key));

      return false;
    }

    return true;
  }

  function prev(e) {
    const found = e.target.parentElement?.parentElement?.previousElementSibling?.firstElementChild;

    if (found) {
      found.focus();
    } else {
      refSearch.value?.focus();
    }
  }

  function next(e, closable) {
    const found = e.target.parentElement?.parentElement?.nextElementSibling?.firstElementChild;

    if (found) {
      found.focus();
    } else if (closable) {
      toggle(false);
    }
  }

  function first() {
    refList.value.firstElementChild?.firstElementChild?.focus();
  }

  return {
    visible,
    query,
    limited,
    results,
    toggle,
    search,
    prev,
    next,
    first,
  };
}
